import { useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { useCurrentSelectedEditableIds } from './utility'
import { useGetTreeById } from '../../reducers/trees_hooks'
import { treeAtom } from '../../components/tree/summaries/atoms'
import { Box, Button } from '@mui/material'
import { TreeSummaries } from '../../components/tree/summaries/Summaries'
import React from 'react'
import {
  NodeSearchParams,
  openNode,
} from '../../components/utility/TreeNavigation'

export function SelectedMasterData() {
  const ids = useCurrentSelectedEditableIds()
  const { tree, resetTree } = useGetTreeById(ids)
  useSetAtom(treeAtom)({ tree, resetTree })

  return (
    <Box>
      <Box padding="10px">
        <strong>{tree?.title}</strong>
        <Button
          onClick={() =>
            openNode({
              tree_id: tree?.tree_id,
              version: tree?.version,
            } as NodeSearchParams)
          }
        >
          Go
        </Button>
      </Box>
      <TreeSummaries />
    </Box>
  )
}
